<template>
  <b-card>
    <b-row align-h="start"> </b-row>
    <template v-slot:header>
      <b-row align-v="center">
        <b-col sm="auto" md="9">
          <div class="text-left">
            <h4>Material</h4>
          </div>
        </b-col>
        <b-col sm="auto" md="3">
          <div class="text-right">
            <!-- <b-button
              title="Add"
              v-on:click="addSize()"
              size="sm"
              variant="outline-success"
              style="margin-right: 5px"
            >
              <b-icon icon="journal-plus" aria-label="Add"></b-icon>
              Add Brand
            </b-button> -->
          </div>
        </b-col>
      </b-row>
    </template>
    <b-row align-h="start">
      <b-col lg="4">
        <b-form-group
          label="Search"
          label-for="Search-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="Search-input"
              v-model="search"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!search" @click="search = ''"
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-center mb-3">
      <!-- <b-spinner
        variant="primary"
        v-show="isLoading"
        label="Loading..."
      ></b-spinner> -->
    </div>
    <b-table
      :no-border-collapse="true"
      striped
      class="header-background"
      hover
      outlined
      show-empty
      responsive
      :per-page="paging.perPage"
      :current-page="paging.currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      @filtered="onFiltered"
      :filter="search"
      :fields="fields"
      :items="dataTable"
    >
      <template #empty="scope">
        <p class="text-center">{{ scope.emptyText }}</p>
      </template>

      <!-- Est Employee -->
      <!-- <template #cell(est_employee)="row">
        <span
          v-if="row.value !== null"
          v-html="FormatCommaNumber(row.value)"
        ></span>
      </template> -->

      <template #cell(action)="row">
        <b-button
          title="View"
          size="xs"
          variant="outline-info"
          v-on:click="showData(row)"
          style="margin-right: 5px"
        >
          <b-icon icon="eye-fill" aria-label="Edit"></b-icon>
        </b-button>
        <!-- <b-button
          v-if="btnEdit"
          title="Edit"
          size="xs"
          variant="outline-warning"
          v-on:click="editData(row)"
          style="margin-right: 5px"
        >
          <b-icon icon="pencil-fill" aria-label="Edit"></b-icon>
        </b-button> -->
        <!-- <b-button
          v-if="btnRemove"
          title="Remove"
          size="xs"
          variant="outline-danger"
          v-on:click="removeData(row)"
          style="margin-right: 5px"
        >
          <b-icon icon="trash-fill" aria-label="Remove"></b-icon>
        </b-button> -->
      </template>
    </b-table>
    <b-row>
      <b-col sm="4">
        Showing {{ showPerPage }} of {{ totalData }} entries
      </b-col>
      <b-col sm="4"> </b-col>
      <b-col sm="4" align-self="end" class="my-1">
        <b-pagination
          v-model="paging.currentPage"
          :total-rows="rows"
          :per-page="paging.perPage"
          align="right"
          size="sm"
        >
          <template #first-text><span class="">First</span></template>
          <template #prev-text><span class="">Prev</span></template>
          <template #next-text><span class="">Next</span></template>
          <template #last-text><span class="">Last</span></template>
          <template #page="{ page, active }">
            <b v-if="active">{{ Pagination(page) }} {{ page }}</b>
            <i v-else>{{ page }}</i>
          </template>
        </b-pagination>
      </b-col>
    </b-row>

    <b-modal
      title="Inactive Size"
      v-model="modalRemove"
      ok-variant="danger"
      cancel-variant="warning"
      header-bg-variant="secondary"
      hide-footer
      hide-header-close
      hide-backdrop
      size="md"
      no-close-on-backdrop
    >
      <b-form>
        <b-form-group
          label="Reason *"
          label-class="text-primary"
          label-cols="2"
          label-cols-md="2"
          label-size="sm"
        >
          <b-form-textarea
            id="textarea-no-resize"
            placeholder="Enter Your Reason..."
            rows="3"
            v-model="reason"
            no-resize
          >
          </b-form-textarea>
          <span
            id="warning-reason"
            class="display-hidden text-small text-danger"
          >
            Required
          </span>
        </b-form-group>
        <b-row align-h="end">
          <b-col sm="3">
            <!-- save  -->
            <b-button
              block
              size="md"
              type="button"
              variant="danger"
              @click="checkBox()"
            >
              Remove
            </b-button>
          </b-col>
          <b-col sm="3">
            <b-button
              block
              size="md"
              @click="cancelBox()"
              type="button"
              variant="warning"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal
      v-model="showModal"
      ok-variant="success"
      cancel-variant="warning"
      header-bg-variant="secondary"
      hide-footer
      hide-header-close
      hide-backdrop
      size="lg"
      no-close-on-backdrop
      title="Add Size"
    >
      <div id="modal">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Code"
              label-class="text-primary"
              label-cols="5"
              label-cols-md="5"
              label-size="sm"
            >
              <b-form-input
                v-model="code"
                placeholder="Size"
                trim
              ></b-form-input>
              <span
                id="warning-code"
                class="display-hidden text-small text-danger"
              >
                Required
              </span>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Brand"
              label-class="text-primary"
              label-cols="5"
              label-cols-md="5"
              label-size="sm"
            >
              <b-form-input
                v-model="brand"
                placeholder="brand"
                trim
              ></b-form-input>
              <span
                id="warning-brand"
                class="display-hidden text-small text-danger"
              >
                Required
              </span>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="editForm">
            <b-form-group
              label="Reason *"
              label-class="text-primary"
              label-cols="1"
              label-cols-md="1"
              label-size="sm"
            >
              <b-form-textarea
                id="textarea-no-resize"
                :readonly="showForm"
                placeholder="Enter Your Reason..."
                rows="3"
                v-model="reason"
                no-resize
              >
              </b-form-textarea>
              <span
                id="warning-reason"
                class="display-hidden text-small text-danger"
              >
                Required
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <!-- save  -->
          <b-col sm="3" v-if="!editForm">
            <b-button
              block
              size="md"
              type="button"
              variant="success"
              @click="checkBox()"
            >
              Save
            </b-button>
          </b-col>

          <!-- edit  -->
          <b-col sm="3" v-if="editForm && !showForm">
            <b-button
              block
              size="md"
              type="button"
              variant="success"
              @click="checkBox()"
            >
              Submit
            </b-button>
          </b-col>
          <b-col sm="3">
            <b-button
              block
              size="md"
              @click="cancelBox()"
              type="button"
              variant="warning"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-card>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";
export default {
  components: {},
  data() {
    return {
      formName: "Master List",
      sortBy: "",
      sortDesc: true,
      roles_list: [],
      dataTable: [],
      fields: [
        // { key: "action", label: "Action", sortable: false },
        // {
        //   key: "code",
        //   label: "code",
        // },
        {
          key: "name",
          label: "name",
        },
      ],
      showPerPage: 0,
      totalData: 0,
      search: null,
      PageNow: 1,
      paging: {
        perPage: 10,
        currentPage: 1,
      },

      form_filter: null,
      form: {
        role: null,
        start_limit: null,
        end_limit: null,
        user_nik: null,
        username: null,
      },
      showModal: false,
      modalRemove: false,
      showForm: false,

      idData: null,
      code: null,
      brand: null,
      reason: null,
      active: true,

      editForm: false,
      btnEdit: false,
      btnRemove: false,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
    rows() {
      if (this.totalData != null) {
        return this.totalData;
      }
    },
  },
  methods: {
    ...mapActions("session", ["showNotification"]),

    setData() {
      this.form.user_nik = this.userData.username;
      this.form.username = this.userData.fullname;
      this.LoadData();
      let roles = this.userData.roles;
      if (roles.length > 0) {
        for (let data in roles) {
          if (roles[data].app == "SFC") {
            let lower = roles[data].role_list.map((string) => {
              return string.toLowerCase();
            });
            this.roles_list = lower;
          }
        }
      }
      if (
        this.roles_list.includes("user-master") ||
        this.roles_list.includes("superuser")
      ) {
        this.btnEdit = true;
        this.btnRemove = true;
      }
    },

    LoadData() {
      this.$emit("loadingHandle", true);
      fnPOST(APIPATH_SALESFORCE.masterMaterial, {
        category: "read",
      })
        .then((rsp) => {
          this.$emit("loadingHandle", false);
          this.dataTable = rsp.data.payload;
          this.totalData = rsp.data.payload.length;
          this.showPerPage = this.paging.perPage;
          if (this.totalData < this.paging.perPage) {
            this.showPerPage = this.totalData;
          }
          if (rsp.data.payload.length == 0) {
            this.showNotification({
              type: "info",
              message: "Data Not Found",
            });
          }
        })
        .catch((err) => {
          this.$emit("loadingHandle", false);
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message:
                "###  Failed to Load data  ### <br/>" +
                err.response.data.message,
            });
          }
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalData = filteredItems.length;
      this.paging.currentPage = 1;
      this.showPerPage = filteredItems.length;
      if (filteredItems.length >= this.paging.perPage) {
        this.showPerPage = this.paging.perPage;
      }
    },
    Pagination(value) {
      if (value !== this.PageNow) {
        if (value > this.PageNow) {
          this.PageNow = value;
          // this.nextPage()
          this.showPerPage = this.paging.perPage * this.PageNow;
          if (this.showPerPage >= this.totalData) {
            this.showPerPage = this.totalData;
          }
        } else {
          this.PageNow = value;
          this.showPerPage =
            this.showPerPage -
            (this.showPerPage - this.paging.perPage * this.PageNow);
          if (this.showPerPage <= this.paging.perPage) {
            this.showPerPage = this.paging.perPage;
          }
        }
      }
    },
    toTitleCase(str) {
      return str
        .toLowerCase()
        .split(" ")
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    },
    FormatCommaNumber(param) {
      let format = param;
      if (param == null || param == undefined || param == "") {
        format = null;
      } else {
        // format = param.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        format = param.toString();
      }
      return format;
    },

    addSize() {
      this.showModal = true;
    },

    showData(row) {
      this.idData = row.item.id;
      this.code = row.item.code;
      this.brand = row.item.brand;
      this.reason = row.item.reason;
      this.showModal = true;
      this.editForm = true;
      this.active = true;
      this.showForm = true;
    },

    editData(row) {
      this.idData = row.item.id;
      this.code = row.item.code;
      this.brand = row.item.brand;
      this.reason = row.item.reason;
      this.showModal = true;
      this.showForm = false;
      this.active = true;
      this.editForm = true;
    },

    removeData(row) {
      this.idData = row.item.id;
      this.code = row.item.code;
      this.brand = row.item.brand;
      this.reason = null;
      this.active = false;
      this.modalRemove = true;
    },

    msgBox(val) {
      let Boxtrue = "";
      let varOk = "danger";
      if (val !== "remove") {
        varOk = "success";
      }
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to " + val + " ? ", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: varOk,
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          Boxtrue = value;
          if (Boxtrue == true) {
            if (val == "submit") {
              this.postDataBox(val);
            }
            if (val == "edit") {
              this.editDataBox(val);
            }
            if (val == "remove") {
              this.editDataBox(val);
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    checkBox() {
      if (
        this.code == null ||
        this.code == "" ||
        this.code.substring(0, 1) == " "
      ) {
        document
          .getElementById("warning-code")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-code")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }
      if (
        this.brand == null ||
        this.brand == "" ||
        this.brand.substring(0, 1) == " "
      ) {
        document
          .getElementById("warning-brand")
          .classList.remove("display-hidden");
        setTimeout(() => {
          document
            .getElementById("warning-brand")
            .classList.add("display-hidden");
        }, 5000);
        return false;
      }

      if (this.editForm || this.modalRemove) {
        if (
          this.reason == null ||
          this.reason == "" ||
          this.reason.substring(0, 1) == " "
        ) {
          document
            .getElementById("warning-reason")
            .classList.remove("display-hidden");
          setTimeout(() => {
            document
              .getElementById("warning-reason")
              .classList.add("display-hidden");
          }, 5000);
          return false;
        }
      }

      this.code = this.code.toUpperCase()
      this.brand = this.brand.toUpperCase()

      let sub = "submit";
      if (this.editForm) {
        sub = "edit";
      }
      if (this.modalRemove) {
        sub = "remove";
      }

      this.msgBox(sub);
    },
    postDataBox(val) {
      this.$emit("loadingHandle", true);
      fnPOST(APIPATH_SALESFORCE.postmasterMaterial, {
        code: this.code,
        brand: this.brand,
        user_nik: this.form.user_nik,
        user_name: this.form.username,
      })
        .then((rsp) => {
          this.$emit("loadingHandle", false);
          this.cancelBox();
          this.LoadData();
        })
        .catch((err) => {
          this.$emit("loadingHandle", false);
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message:
                "###  Failed to Submit data  ### <br/>" +
                err.response.data.message,
            });
          }
        });
    },
    editDataBox(val) {
      this.$emit("loadingHandle", true);
      fnPOST(APIPATH_SALESFORCE.editmasterMaterial, {
        id: this.idData,
        code: this.code,
        brand: this.brand,
        reason: this.reason,
        is_active: this.active,
        user_nik: this.form.user_nik,
        user_name: this.form.username,
      })
        .then((rsp) => {
          this.$emit("loadingHandle", false);
          this.cancelBox();
          this.LoadData();
        })
        .catch((err) => {
          this.$emit("loadingHandle", false);
          if (err.response.status !== 401) {
            this.showNotification({
              type: "error",
              message:
                "###  Failed to Submit data  ### <br/>" +
                err.response.data.message,
            });
          }
        });
    },
    cancelBox() {
      this.showModal = false;
      this.modalRemove = false;
      setTimeout(() => {
        this.idData = null;
        this.code = null;
        this.brand = null;
        this.reason = null;
        this.active = true;
        this.editForm = false;
        this.showForm = false;
      }, 200);
    },
  },
  created() {},
};
</script>
<style src="../SalesForce.scss" lang="scss" scoped />
